<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="50%"
    modal
    @close="handleClose"
    :show-close="false"
    :close-on-click-modal="false">
    <div class="questionContent">
      <el-row>{{currentQuestion.content}}</el-row>
      <el-row v-if="currentQuestion.type == '0'" class="answer">
        <el-radio-group v-model="judgeAnswer">
          <el-radio label="正确">正确</el-radio>
          <el-radio label="错误" >错误</el-radio>
        </el-radio-group>
      </el-row>
      <el-row v-if="currentQuestion.type == '1'" class="answer">
        <el-radio-group v-model="radioAnswer">
          <el-radio v-for="(value,key) in currentQuestion.options"  :label="key">
            {{key+'.'+value}}
          </el-radio>
        </el-radio-group>

      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAnswer(currentQuestion.type,currentQuestion.correctAnswer)"
                   size="small">提 交
        </el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: "QuestionDialog",
    props: {
      questionList: Array  // 该小节的题目
    },
    data() {
      return {
        // 当前题目索引
        currentIndex: -1,
        currentQuestion: {
          options: {}
        },
        dialogVisible: false,
        // 答案
        judgeAnswer: "正确",
        radioAnswer: 'A',
        title: '学习过程记录 ',

      }
    },
    methods: {
      // 获取当前题目
      getCurrentQuestion(questionBankId) {
        this.currentQuestion = {}
        this.currentQuestion = this.questionList.filter(item => item.questionBankId === questionBankId)[0]
        if (this.currentQuestion.type == '1') {
          this.currentQuestion.options = JSON.parse(this.currentQuestion.options);
        }
        this.title += this.currentQuestion.type === '0' ? '(单选题)': '(选择题)';
      },
      // 获得题库集合
      async getQuestionBankList() {
        const {content} =  await this.$http.get('/business/web/questionBank/list');
        LocalStorage.set(QUESTION_BANK_LIST,content);
        LocalStorage.set(QUESTION_BANK_LIST_INDEX,-1);
        let questionBankList = LocalStorage.get(QUESTION_BANK_LIST);
        let index = LocalStorage.get(QUESTION_BANK_LIST_INDEX);
        this.getQuestionContent(index,questionBankList);
      },
      getQuestionBank() {
        let questionBankList = LocalStorage.get(QUESTION_BANK_LIST);
        let index = LocalStorage.get(QUESTION_BANK_LIST_INDEX);
        if (questionBankList == undefined || index == undefined  || parseInt(index) + 1 >= questionBankList.length) {
          this.getQuestionBankList();
        }
        else {
          this.getQuestionContent(index,questionBankList);
        }
      },
      getQuestionContent(index,questionBankList) {
        this.currentIndex = parseInt(index) + 1;
        this.currentQuestion = questionBankList[this.currentIndex];
        if (this.currentQuestion.type == '1') {
          this.currentQuestion.options = JSON.parse(this.currentQuestion.options);
        }
        this.title += this.currentQuestion.type === '0' ? '(单选题)': '(选择题)';

        LocalStorage.set(QUESTION_BANK_LIST_INDEX,this.currentIndex);
      },
      // 当弹题对话框关闭
      handleClose() {
        this.currentQuestion = '';
        this.judgeAnswer = '正确';
        this.radioAnswer= 'A';
        this.title = "学习过程记录";
        // 向父组件传送
        this.$emit("submitAnswer");
      },
      submitAnswer(type,correctAnswer) {
        if (type == '0') {
          if(correctAnswer == this.judgeAnswer) {
            this.$message.success("真厉害！答案正确！");
            this.dialogVisible = false;
          }else {
            this.$message.warning("答案错误！请重新答题哟！");
          }
        } else {
          if(correctAnswer == this.radioAnswer) {
            this.$message.success("真厉害！答案正确！");
            this.dialogVisible = false;
          }else {
            this.$message.warning("答案错误！请重新答题哟！");
          }
        }
      },
    }
  }
</script>

<style scoped>
  .questionContent {
    text-align: left;
    margin-top: -10px;
  }
  .answer {
    padding-top: 15px;
    text-align: left;
    padding-left: 5px;
  }
  .el-radio {
    margin-top: 5px;
    width: 100%;
    text-overflow: ellipsis;
    white-space: normal;
  }

</style>
